import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';

export const useCampaigns = (placement, options = {}) => {
  const { productId, categoryId, type, enabled = true } = options;

  return useQuery({
    queryKey: ['campaigns', placement, productId, categoryId, type],
    queryFn: async () => {
      const response = await apiService.getCampaignsByPlacement(placement, {
        productId,
        categoryId,
        type,
      });
      return response?.data ?? [];
    },
    enabled: enabled && Boolean(placement),
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: true,
  });
};

export const useActiveCampaigns = (options = {}) => {
  const { enabled = true, ...params } = options;

  return useQuery({
    queryKey: ['campaigns', 'active', params],
    queryFn: async () => {
      const response = await apiService.getActiveCampaigns(params);
      return response?.data ?? [];
    },
    enabled,
    staleTime: 1000 * 60 * 2,
  });
};

export default useCampaigns;
